/// <reference path="compensationSettings.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Controls {
    class SplitCommissionEditorController {

        static $inject = ["context", "splitItem", "$filter", "$mdDialog"];
        public context: any;
        public splitItem: any;
        public isAdding: boolean;
        public todayDate: Date;
        constructor(context: any, splitItem: Model.SplitCommissionSetting, protected $filter: angular.IFilterService, private $mdDialog: angular.material.IDialogService) {
            this.context = context;
            this.isAdding = splitItem === null || splitItem === undefined;
            this.splitItem = this.isAdding ? { displayName: "", firstEmployeeValue: 1, secondEmployeeValue: 0 } : splitItem;
            this.todayDate = moment().toDate();
        }

        apply = () => {
            if (this.isAdding) {
                this.context.selectedSection.addSplitCommission(this.splitItem, null);
            }

            this.$mdDialog.hide();
        }
        cancel = () => {
            this.$mdDialog.hide();
        }
        onAmountFirstChange=() => {
            this.splitItem.secondEmployeeValue = 1 - this.splitItem.firstEmployeeValue;
            this.splitItem.secondEmployeeDisplay = parseFloat(this.splitItem.secondEmployeeValue) * 100 + '%';
        }
        onAmountSecondChange = () => {
            this.splitItem.firstEmployeeValue = 1 - this.splitItem.secondEmployeeValue;
            this.splitItem.firstEmployeeDisplay = parseFloat(this.splitItem.firstEmployeeValue) * 100 + '%';
        }
    }

    angular.module("meevo.plugins.compensationSettings")
        .controller("meevo.plugins.SplitCommissionEditorController", SplitCommissionEditorController);
}